module.exports = __webpack_public_path__ + "img/oaks-nest-kitchen-2.0c24d643.jpeg";